import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';

import { BrainstormIcon } from '../../../../icons/prompt/brainstorm';
import { createInsertAtCurrentPosition } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const createDraftReply = (issueId?: string): EditorPluginAIConfigItem => ({
	key: CONFIG_ITEM_KEYS.SUGGEST_REPONSE,
	title: aiConfigItemMessages.draftReplyTitle,
	description: aiConfigItemMessages.draftReplyDescription,
	icon: () => <BrainstormIcon />,
	endpoint: `/gateway/api/firebolt/1/agent-response/issues/${issueId}/stream`,
	intentSchemaId: 'brainstorm_intent_schema.json',
	featureId: 'brainstorm',
	alwaysNoDocAndSelection: true,
	actions: {
		empty: [
			createInsertAtCurrentPosition({
				appearance: 'primary',
			}),
		],
		selection: [
			createInsertAtCurrentPosition({
				appearance: 'primary',
			}),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
	statusLozengeType: fg('platform_remove_jsm_beta_tags') ? undefined : 'beta',
});

export const createDraftReplyWithOptions = (
	issueId?: string,
): EditorPluginAIConfigItemWithOptions => ({
	config: createDraftReply(issueId),
	triggers: { empty: { enabled: true, docMinSize: 0 }, selection: { enabled: false } },
});
